import axios from 'axios';

// 创建 Axios 实例
const service = axios.create({
  // baseURL: '/prod-api', // 替换为你的接口基础路径
  // baseURL: 'http://8.134.161.101:8080', // 替换为你的接口基础路径
  baseURL: '', // 替换为你的接口基础路径
  timeout: 30000, // 请求超时时间
});

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在请求发送前进行操作，例如添加 token
    // config.headers['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
    return config;
  },
  error => {
    // 处理请求错误
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 处理响应数据
    const res = response.data;
    if(res.code != 0){
      alert(res.msg);
    }
    return response.data;
  },
  error => {
    // 处理响应错误
    console.error('Response Error:', error);
    return Promise.reject(error);
  }
);

export default service;
